import BaseComponent from './BaseComponent';


// TODO REFACTOR THIS COMPONENT AND THE ACCORDION RADIO, AS A SINGLE ONE WITH PARAMS
class Accordion extends BaseComponent {
  constructor(componentName){
    super(componentName);
  }


  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    component.element.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleComponent(component.element);
    });


    window.addEventListener('resize', _.throttle((e) => {
      if(component.element.classList.contains('opened')) {
        const contents = this.getAccordionContent(component.element);
        this.watchResize(contents);
      }
    }, 500));
  }


  toggleComponent(element, collapse = undefined) {
    const keepOpen = element.getAttribute('data-keep-open') == 'true' ? true : false;
    requestAnimationFrame(() => {
      const contents = this.getAccordionContent(element);
      this.toggleAccordionContent(contents, collapse, keepOpen);
      this.toggleSymbol(element, keepOpen);
    });

    this.toggleState(element);
  }


  toggleState(element, keepOpen) {
    if(!keepOpen) element.classList.toggle('opened');

    const input = element.getElementsByTagName('input')[0];
    if(!!input) {
      input.checked = input.checked ? false : true;
    }
  }


  getAccordionContent(element) {
    // const doubleContent = element.getAttribute('data-double-content') == 'true' ? true : false;
    const input = element.getElementsByTagName('input')[0];

    // let contentId;
    // if(doubleContent && !!input && !input.checked) {
    //   contentId = element.getAttribute('data-accordion-id');
    // } else if (doubleContent && !!input && input.checked) {
    //   contentId = element.getAttribute('data-accordion-id-false');
    // } else {
      const contentId = element.getAttribute('data-accordion-id');
    // }


    const contentWrappers = document.getElementsByClassName('accordion__content-wrapper');
    let contentsTarget = [];

    for(let content of contentWrappers) {
      const dataId = content.getAttribute('data-id');

      if(dataId === contentId) {
        contentsTarget.push(content);
      }
    }

    return contentsTarget;
  }


  toggleAccordionContent(targets, collapse, keepOpen) {
    if(targets.length > 0) {
      for (let target of targets) {
        if (!!target) {

          // !!collapse && true ? target.classList.remove('visible') : target.classList.toggle('visible');

          target.classList.toggle('visible');

          if (target.classList.contains('visible')) {
            target.style.height = target.scrollHeight + 'px';
          } else {
            target.style.height = 0;
          }
        }
      }
    }
  }


  lockContent(element, disabled) {
    const contents = this.getAccordionContent(element);
    for (let content of contents) {
      disabled ? content.classList.add('disabled') : content.classList.remove('disabled');
    }
  }


  watchResize(targets) {
    if(targets.length > 0) {
      for (let target of targets) {
        if (!!target) {
          if (target.classList.contains('visible')) {
            const content = target.getElementsByClassName('accordion__content')[0];
            target.style.height = !!content ? content.scrollHeight + 'px' : target.scrollHeight + 'px';
          } else {
            target.style.height = 0;
          }
        }
      }
    }
  }


  toggleSymbol(element) {
    const symbol = element.getElementsByClassName('symbol')[0];
    if(!!symbol) symbol.classList.toggle('expanded');
  }
}

export default Accordion;
